import React, { useState } from 'react';
import { FaExchangeAlt, FaHashtag, FaTags, FaFileExcel, FaCalculator } from 'react-icons/fa';
import MassClientTransferUtility from './MassClientTransferUtility';
import MassFseCodeUpdateUtility from './MassFseCodeUpdateUtility';
import MassPriceUpdateUtility from './MassPriceUpdateUtility';
import ImportJobSchedulesUtility from './ImportJobSchedulesUtility';
import QuoteCalculatorUtility from './QuoteCalculatorUtility';

const UtilitiesPage = () => {
    const [activeUtility, setActiveUtility] = useState(null);

    if (activeUtility === 'mass-transfer') {
        return <MassClientTransferUtility onBack={() => setActiveUtility(null)} />;
    }

    if (activeUtility === 'fse-code-update') {
        return <MassFseCodeUpdateUtility onBack={() => setActiveUtility(null)} />;
    }

    if (activeUtility === 'bulk-price-update') {
        return <MassPriceUpdateUtility onBack={() => setActiveUtility(null)} />;
    }

    if (activeUtility === 'import-job-schedules') {
        return <ImportJobSchedulesUtility onBack={() => setActiveUtility(null)} />;
    }

    if (activeUtility === 'quote-calculator') {
        return <QuoteCalculatorUtility onBack={() => setActiveUtility(null)} />;
    }

    return (
        <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between mb-6 px-4 sm:px-0">
                <h1 className="text-2xl font-semibold text-gray-900">Select a Utility</h1>
            </div>
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 px-4 sm:px-0">
                
                <div 
                    onClick={() => setActiveUtility('mass-transfer')}
                    className="bg-white overflow-hidden shadow rounded-lg border border-gray-200 hover:border-jims-green hover:shadow-md cursor-pointer transition-all duration-200"
                >
                    <div className="p-5 flex items-center">
                        <div className="flex-shrink-0 bg-blue-100 rounded-md p-3">
                            <FaExchangeAlt className="h-6 w-6 text-blue-600" />
                        </div>
                        <div className="ml-5">
                            <h3 className="text-lg leading-6 font-medium text-gray-900">Mass Client Transfer</h3>
                            <div className="mt-2 max-w-xl text-sm text-gray-500">
                                Transfer all clients, schedules, and pending jobs from one franchisee to another.
                            </div>
                        </div>
                    </div>
                </div>

                <div 
                    onClick={() => setActiveUtility('fse-code-update')}
                    className="bg-white overflow-hidden shadow rounded-lg border border-gray-200 hover:border-jims-green hover:shadow-md cursor-pointer transition-all duration-200"
                >
                    <div className="p-5 flex items-center">
                        <div className="flex-shrink-0 bg-purple-100 rounded-md p-3">
                            <FaHashtag className="h-6 w-6 text-purple-600" />
                        </div>
                        <div className="ml-5">
                            <h3 className="text-lg leading-6 font-medium text-gray-900">System FSE Code Update</h3>
                            <div className="mt-2 max-w-xl text-sm text-gray-500">
                                Update the FSE Code for a single franchisee across all historical jobs, invoices, and RCTIs.
                            </div>
                        </div>
                    </div>
                </div>

                <div 
                    onClick={() => setActiveUtility('bulk-price-update')}
                    className="bg-white overflow-hidden shadow rounded-lg border border-gray-200 hover:border-jims-green hover:shadow-md cursor-pointer transition-all duration-200"
                >
                    <div className="p-5 flex items-center">
                        <div className="flex-shrink-0 bg-green-100 rounded-md p-3">
                            <FaTags className="h-6 w-6 text-green-600" />
                        </div>
                        <div className="ml-5">
                            <h3 className="text-lg leading-6 font-medium text-gray-900">Bulk Price Update</h3>
                            <div className="mt-2 max-w-xl text-sm text-gray-500">
                                Set service prices and push them across selected or all suppliers in one operation.
                            </div>
                        </div>
                    </div>
                </div>

                <div 
                    onClick={() => setActiveUtility('import-job-schedules')}
                    className="bg-white overflow-hidden shadow rounded-lg border border-gray-200 hover:border-jims-green hover:shadow-md cursor-pointer transition-all duration-200"
                >
                    <div className="p-5 flex items-center">
                        <div className="flex-shrink-0 bg-orange-100 rounded-md p-3">
                            <FaFileExcel className="h-6 w-6 text-orange-600" />
                        </div>
                        <div className="ml-5">
                            <h3 className="text-lg leading-6 font-medium text-gray-900">Import Job Schedules</h3>
                            <div className="mt-2 max-w-xl text-sm text-gray-500">
                                Upload an Excel file to preview and selectively import job schedules into the system.
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    onClick={() => setActiveUtility('quote-calculator')}
                    className="bg-white overflow-hidden shadow rounded-lg border border-gray-200 hover:border-jims-green hover:shadow-md cursor-pointer transition-all duration-200"
                >
                    <div className="p-5 flex items-center">
                        <div className="flex-shrink-0 bg-cyan-100 rounded-md p-3">
                            <FaCalculator className="h-6 w-6 text-cyan-600" />
                        </div>
                        <div className="ml-5">
                            <h3 className="text-lg leading-6 font-medium text-gray-900">Quote Calculator</h3>
                            <div className="mt-2 max-w-xl text-sm text-gray-500">
                                Work out invoice prices from a franchisee price without creating a job schedule.
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default UtilitiesPage;